var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTagInteractive",
    {
      staticClass: "listing-table-actions__filters-tag",
      attrs: { modelValue: _vm.type, color: "gray" },
      on: { "tag-remove": _vm.handleRemoveFilter }
    },
    [
      _c("template", { slot: "default" }, [
        _c(
          "div",
          {
            staticClass: "filters-tag__label",
            on: { click: _vm.handleClickOnTag }
          },
          [
            _c("span", { staticClass: "typographies-paragraph-medium-bold" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.label + " :") +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "typographies-paragraph-medium-regular" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.valuesHumanized) +
                    "\n            "
                )
              ]
            )
          ]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }